/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Italian16Inputs */

const en__field__enum_teachingsubjectinterest_subject_italian16 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Italian16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italian`)
};

const de__field__enum_teachingsubjectinterest_subject_italian16 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Italian16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italienisch`)
};

/**
* | output |
* | --- |
* | "Italian" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Italian16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_italian16 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Italian16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Italian16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_italian16(inputs)
	return de__field__enum_teachingsubjectinterest_subject_italian16(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_italian16 as "_field__enum_teachingSubjectInterest_SUBJECT_ITALIAN" }